.root {

  &.sticky {
    position: sticky;
    top: 0;
    background: var(--theme--color--mono--white);
    z-index: 1;
  }

  &.withDivider {
    border-bottom: solid 1px var(--theme--color--grey--light);
  }

  &.buttonSuffix {
    padding-right: calc(var(--theme--tokens--card--padding) - 6px);
  }

  & {
    flex-shrink: 0;
    padding: var(--theme--tokens--card--padding);
    padding-bottom: calc(var(--theme--tokens--card--padding) / 2);
  }
}
